export const preenchimentoCor = (texto, pedido, trackingTemp) => {
  //  if(texto?.length > 2)
  //  {
  return pedido?.StatusPedido
  //  }
  //  return "";
}

// export const changePedidoStatusToTag = (status) => {

//   return status

//   // Código abaixo ficou obsoleto
//   // let tag = ''

//   // switch (status) {
//   //   case 'PEDIDO_EM_TRANSPORTE':
//   //     tag = 'Em transporte'
//   //     break
//   //   case 'PEDIDO_ENTREGUE':
//   //     tag = 'Entregue'
//   //     break
//   //   case 'PEDIDO_CANCELADO':
//   //     tag = 'Cancelado'
//   //     break
//   //   case 'AGUARDANDO_LIBERACAO':
//   //     tag = 'Aguardando Liberação'
//   //     break
//   //   case 'AGUARDANDO_PAGAMENTO':
//   //     tag = 'Aguardando Pagamento'
//   //     break
//   //   case 'AGUARDANDO_FECHAMENTO_B2B':
//   //     tag = 'Aguardando Fechamento B2B'
//   //     break
//   //   case 'SEPARACAO_DE_PRODUTO':
//   //     tag = 'Em separação'
//   //     break
//   //   case 'PEDIDO_EFETUADO':
//   //     tag = 'Efetuado'
//   //     break
//   //   case 'DEVOLVIDO':
//   //     tag = 'Devolvido'
//   //     break
//   //   case 'PROCESSAMENTO_PEDIDO':
//   //     tag = 'Processando'
//   //     break
//   //   case 'EMISSAO_DE_NOTA_FISCAL':
//   //     tag = 'Emissão de Nota Fiscal'
//   //     break
//   //   default:
//   //     return status
//   //     break
//   //}

//   //return tag
// }

export const getPedidoStatusColor = (status) => {
  // console.log("status: " + status)
  // if(status == '')
  //   return ''

  let color = ''

  switch (status) {
    case 'PEDIDO_EM_TRANSPORTE':
      color = 'green'
      break
    case 'PEDIDO_ENTREGUE':
      color = 'green'
      break
    case 'PEDIDO_CANCELADO':
      color = 'red'
      break
    case 'AGUARDANDO_LIBERACAO':
      color = 'green'
      break
    case 'AGUARDANDO_PAGAMENTO':
      color = 'green'
      break
    case 'AGUARDANDO_FECHAMENTO_B2B':
      color = 'green'
      break
    case 'SEPARACAO_DE_PRODUTO':
      color = 'green'
      break
    case 'PEDIDO_EFETUADO':
      color = 'green'
      break
    case 'DEVOLVIDO':
      color = 'green'
      break
    case 'PROCESSAMENTO_PEDIDO':
      color = 'green'
      break
    case 'EMISSAO_DE_NOTA_FISCAL':
      color = 'green'
      break
    default:
      break
  }

  return color
}

const capitalizeFirstLetters = (str) => {
  if (!str) return ''
  return str.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase()
  })
}

export const getSortedStatusByDate = (remessas, pedido) => {
  let array = []

  const arrayTracking = remessas !== undefined ? remessas[0]?.Tracking : []

  const trackingVazio =
    remessas !== undefined &&
    remessas[remessas.findIndex((x) => x.Tracking.length === 0)]

  if (trackingVazio !== undefined) {
    // if(remessas.length > 1)
    // { return ' '}

    return pedido.StatusPedido
  } else if (remessas?.length === 1) {
    // if(remessas[0].SellerId != null || remessas[0].SellerId > 0 )
    // { return '' }

    const statusValidos = arrayTracking.filter((element) => {
      return new Date(element.DataHoraMovimentacao).getFullYear() > 2001
    })

    statusValidos.sort((a, b) => parseFloat(a.Id) - parseFloat(b.Id))

    const last = statusValidos[statusValidos?.length - 1]

    //console.log("Pedido:" + pedido.IdPedido + "Status: "+ last?.DescricaoStatus )
    return capitalizeFirstLetters(last?.DescricaoStatus)
  } else {
    remessas?.map((seller) => {
      array.push(seller?.Tracking[seller.Tracking.length - 1])
    })

    const newArray = array.sort((a, b) => {
      return new Date(a.DataHoraMovimentacao) - new Date(b.DataHoraMovimentacao)
    })

    const novo = newArray.filter((element) => {
      return new Date(element.DataHoraMovimentacao).getFullYear() > 2001
    })

    //  if(remessas.length > 1)
    //     {
    //       console.log("remessa: " + remessas)
    //       return ' '}

    return novo[0]?.PedidoSituacao
  }
}

export const getLastTrackingColor = (remessas) => {
  if (remessas.length === 1) {
    const lastTracking = remessas[0]?.Tracking || []
    const statusCor = lastTracking
      .slice()
      .reverse()
      .find(
        (tracking) => tracking.DataHoraMovimentacao !== '0001-01-01T00:00:00'
      )?.StatusCor

    if (statusCor) {
      return statusCor
    }
  } else {
    for (let i = remessas.length - 1; i >= 0; i--) {
      const lastTracking = remessas[i]?.Tracking || []
      const statusCor = lastTracking.find(
        (tracking) =>
          tracking.DataHoraMovimentacao !== '0001-01-01T00:00:00' &&
          tracking.StatusCor === 'VERMELHO'
      )?.StatusCor

      if (statusCor === 'VERMELHO') {
        return statusCor
      }
    }

    for (let i = remessas.length - 1; i >= 0; i--) {
      const lastTracking = remessas[i]?.Tracking || []
      const statusCor = lastTracking.find(
        (tracking) =>
          tracking.DataHoraMovimentacao !== '0001-01-01T00:00:00' &&
          tracking.StatusCor === 'AMARELO'
      )?.StatusCor

      if (statusCor === 'AMARELO') {
        return statusCor
      }
    }

    for (let i = remessas.length - 1; i >= 0; i--) {
      const lastTracking = remessas[i]?.Tracking || []
      const statusCor = lastTracking
        .slice()
        .reverse()
        .find(
          (tracking) => tracking.DataHoraMovimentacao !== '0001-01-01T00:00:00'
        )?.StatusCor

      if (statusCor) {
        return statusCor
      }
    }
  }

  return ''
}
